package com.schoolconnect.app.feature.mystudents

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember

@Composable
fun TeacherMyStudentsFeatureRoute(
    onBack: () -> Unit,
    homeRoleCode: String = "",
    homeSchoolLabel: String = "iConnect.School",
    onToggleTheme: () -> Unit = {},
    onLogout: () -> Unit = {},
    onHomeRoleChanged: (String, String, String) -> Unit = { _, _, _ -> }
) {
    val viewModel = remember { TeacherMyStudentsViewModel() }
    val state by viewModel.uiState.collectAsState()
    DisposableEffect(viewModel) { onDispose { viewModel.clear() } }
    TeacherMyStudentsScreen(
        state = state,
        onEvent = viewModel::onEvent,
        onBack = onBack,
        shellRoleCode = homeRoleCode,
        shellSchoolLabel = homeSchoolLabel,
        onChangeRole = onBack,
        onLogout = onLogout
    )
}
